import constants from './constants';

export default function formatResourceContainerName(companyId) {
  return `${companyId}_${constants.GROUP_ICONS_CMS_CONTAINER_NAME_SUFFIX}`;
}
